<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lEFbEg/tc-custom/9780062295552.jpg?1718106718570" alt="This image is the cover for the book Freedom Line"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Freedom Line
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Compared to <i>Casablanca</i> by the <i>Washington Post, The Freedom Line</i> is a page-turning story of a group of resistance workers who secreted downed Allied fighter pilots through France and into safety in Spain during World War II—perfect for fans of Apple TV's <i>Masters of the Air</i>.</b></p><p>As war raged against Hitler's Germany, an increasing number of Allied fliers were shot down on missions against Nazi targets in occupied Europe. Many fliers parachuted safely behind enemy lines only to find themselves stranded and hunted down by the Gestapo. <i>The Freedom Line</i> traces the thrilling and true story of Robert Grimes, a 20–year–old American B–17 pilot whose plane was shot down over Belgium on Oct. 20, 1943. Wounded, disoriented, and scared, he was rescued by operatives of the Comet Line, a group of tenacious young women and men from Belgium, France, and Spain who joined forces to rescue the Allied aircrews and take them to safety. And on Christmas Eve 1943, he and a group of fellow Americans faced unexpected sudden danger and tragedy on the border between France and Spain.</p><p>The road to safety was a treacherous journey by train, by bicycle, and on foot that stretched hundreds of miles across occupied France to the Pyrenees Mountains at the Spanish border. Armed with guile and spirit, the selfless civilian fighters of the Comet Line had risked their lives to create this underground railroad, and by this time in the war, they had saved hundreds of Americans, British, Australians, and other Allied airmen.</p><p>Based on interviews with the survivors and in–depth archival research, <i>The Freedom Line</i> is the story of a group of friends who chose to act on their own out of a deep respect for liberty and human dignity. Theirs was a courage that presumed to take on a fearfully powerful foe with few defences.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter Eisner
      </h2>
      
      <p class="authorDescription body article"><P>Peter Eisner has been an editor and reporter at the <I>Washington Post</I>, <I>Newsday</I>, and the <I>Associated Press</I>. His books include the award-winning <I>The Freedom Line</I> and <I>The Italian Letter</I>, which he wrote with Knut Royce. He lives in Bethesda, Maryland.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f90c25a4